/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiRequestTicketCategorySearch } from '../../models/api-request-ticket-category-search';
import { ApiResponsePageTicketCategory } from '../../models/api-response-page-ticket-category';

export interface Search$Params {
      body: ApiRequestTicketCategorySearch
}

export function search(http: HttpClient, rootUrl: string, params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageTicketCategory>> {
  const rb = new RequestBuilder(rootUrl, search.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePageTicketCategory>;
    })
  );
}

search.PATH = '/v1/api/ui/category-ticket/search';
